import { render, staticRenderFns } from "./listProductsWeb.vue?vue&type=template&id=61c66a52&scoped=true&"
import script from "./listProductsWeb.vue?vue&type=script&lang=js&"
export * from "./listProductsWeb.vue?vue&type=script&lang=js&"
import style0 from "./listProductsWeb.vue?vue&type=style&index=0&id=61c66a52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c66a52",
  null
  
)

export default component.exports